module.exports = __webpack_public_path__ + "static/media/M102ws.b1148892.pdf";